module.exports = __webpack_public_path__ + "img/arthritissociety.f86500b9.png";